import "./styles/app.css";
import { createUi } from "@amtana/browser";

import { browserModules } from "./browser-modules.generated.ts";

// `hydrate()` takes over a prerendered page with no mismatch; `pnpm dev`'s unbuilt shell has
// nothing to hydrate, so it falls back to a plain client render (ADR-027 point 3).
createUi({ mount: "root" }).withModules(browserModules).hydrate();
